import type { VueConstructor } from 'vue';

import { SUPPORT_CHAT_INLINE_SELECTOR } from '@/components/app/support-chat/constants';
import { script } from '@/assets/util/append-file';

type StatisticConfig = {
    statistic?: {
        hubspotId?: string;
    };
};

export default {
    install(_Vue: VueConstructor, { config }: { config: StatisticConfig }) {
        if (!config.statistic?.hubspotId) return;

        window.hsConversationsSettings = {
            ...window.hsConversationsSettings,
            inlineEmbedSelector: SUPPORT_CHAT_INLINE_SELECTOR,
            loadImmediately: false,
        };

        script(`//js.hs-scripts.com/${config.statistic.hubspotId}.js`, true, {
            id: 'hs-script-loader',
            defer: true,
        });
    },
};
